<div>
  <div class="box">
    <div class="drag-handle">
      <button (click)="onClickListaCapas()" class="circle-button">
        <div class="button-icon">
          <img *ngIf="this.layerCatalogService.isInternalLayersVisible" [src]="'icon_capas_internas.svg' | findUrl" class="img-button">
          <img *ngIf="!this.layerCatalogService.isInternalLayersVisible" [src]="'icon_capas_internas_gris.svg' | findUrl" class="img-button">
        </div>
      </button>
    </div>
    <div [@mostrarLista]="this.layerCatalogService.isInternalLayersVisible ? 'visible' : 'hidden'" class="switch-list" [ngClass]="{'overflowHidden': this.panelInternalLayerService.isExpandCollapseAnimating}">
      <div>
        <div class="tool-title">
          <mat-icon (click)="toggleInternalLayers()" class="expand-icon" [ngClass]="{'expanded': this.panelInternalLayerService.isInternalLayersExpanded}">expand_more</mat-icon>
          <h2>Capas Internas</h2>
            <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="ClosePanel()"></mat-icon> -->
        </div>

        <div [@expandCollapseLayers]="this.panelInternalLayerService.isInternalLayersExpanded ? 'expanded' : 'collapsed'" (@expandCollapseLayers.start)="onExpandCollapseStart($event)" (@expandCollapseLayers.done)="onExpandCollapseDone($event)" class="switch-container">
          <div class="switch-item" *ngIf="hasGPSCategories && this.panelInternalLayerService.isActiveLayer">
            <label class="switch" [id]='"layer-locationsGeneral"'>
              <img *ngIf="this.panelInternalLayerService.activeLayer.checked" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="onToggleLayerActivos()">
              <img *ngIf="!this.panelInternalLayerService.activeLayer.checked" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="onToggleLayerActivos()">
            </label>
            <span>
              <!-- <img [src]="'nodes.png' | findUrl" class="img-layer">  -->
              Activos </span>
          </div>
          <div class="switch-item" *ngIf="hasGPSCategories && this.panelInternalLayerService.isFilterLayer">
            <label class="switch" [id]='"filter-layer-locationsGeneral"'>
              <img *ngIf="this.panelInternalLayerService.filterLayer.checked" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="onToggleLayerFiltros()">
              <img *ngIf="!this.panelInternalLayerService.filterLayer.checked" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="onToggleLayerFiltros()">
            </label>
            <span>
              <!-- <img [src]="'nodes.png' | findUrl" class="img-layer">  -->
              Activos Filtrados </span>
          </div>

          <ng-container *ngFor="let capa of $capas">
            <div *ngIf="!capa.itWorksAsVirtualLocation" class="switch-item">
              <label class="switch col-3">
                <img *ngIf="capa.checked" [src]="'btn_on.svg' | findUrl" class="img-button" [id]="capa.name" (click)="onToggleLayer(capa)">
                <img *ngIf="!capa.checked" [src]="'btn_off.svg' | findUrl" class="img-button" [id]="capa.name" (click)="onToggleLayer(capa)">
              </label>
              <span class="col-6">
                <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
                {{ capa.name }}
              </span>
              <div class="switch-loading col-3">
                <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
              </div>
            </div>
          </ng-container>
        </div>

        

        <div *ngIf="hasVirtualCategories" class="tool-title">
          <mat-icon (click)="toggleVirtualLayers()" class="expand-icon" [ngClass]="{'expanded': this.panelInternalLayerService.isVirtualLayersExpanded}">expand_more</mat-icon>
          <h2>Capas Virtuales</h2>
        </div>

        <div  *ngIf="hasVirtualCategories" [@expandCollapseLayers]="this.panelInternalLayerService.isVirtualLayersExpanded ? 'expanded' : 'collapsed'"  (@expandCollapseLayers.start)="onExpandCollapseStart($event)" (@expandCollapseLayers.done)="onExpandCollapseDone($event)" class="switch-container">
          <ng-container *ngFor="let capa of $capas">
            <div *ngIf="capa.itWorksAsVirtualLocation" class="switch-item">
              <label class="switch col-3">
                <img *ngIf="capa.checked" [src]="'btn_on.svg' | findUrl" class="img-button" [id]="capa.name" (click)="onToggleLayer(capa)">
                <img *ngIf="!capa.checked" [src]="'btn_off.svg' | findUrl" class="img-button" [id]="capa.name" (click)="onToggleLayer(capa)">
              </label>
              <span class="col-6">
                <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
                {{ capa.name }}
              </span>
              <div class="switch-loading col-3">
                <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- <div *ngFor="let capa of $capas" class="switch-item">
          <label class="switch">
            <img *ngIf="capa.checked" [src]="'btn_on.svg' | findUrl" class="img-button" [id]=capa.name (click)="onToggleLayer(capa)">
            <img *ngIf="!capa.checked" [src]="'btn_off.svg' | findUrl" class="img-button" [id]=capa.name (click)="onToggleLayer(capa)">
          </label>
          <span>
            <img [src]="capa.icon | findUrl" class="img-layer"> comentario
            {{ capa.name }}
          </span>
        </div> -->
      </div>

      <div>
        <app-generated-layers></app-generated-layers>
      </div>
      
    </div>
  </div>
</div>